import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ADD_IMAGES_SURVEYS, DELETE_IMAGES_SURVEYS } from './constants';
import {
  AddImagesSurveysDataActionTypes,
  AddImagesSurveysError,
  AddImagesSurveysState,
  AddImagesSurveysSuccess,
} from './types';

const initialState: AddImagesSurveysState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AddImagesSurveysDataActionTypes,
  ): AddImagesSurveysState => {
    switch (action.type) {
      case ADD_IMAGES_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ADD_IMAGES_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AddImagesSurveysSuccess).payload;
        break;
      }
      case ADD_IMAGES_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AddImagesSurveysError).error;
        break;
      }
      case ADD_IMAGES_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      case DELETE_IMAGES_SURVEYS: {
        draft = initialState;
        return draft;
      }
      default:
        return draft;
    }
  },
);
